export const CARDINAL_STATUSES = {
  success: 'success',
  failure: 'failure',
  error: 'error',
  timeout: 'timeout',
  connectivity: 'connectivity',
  hasNotInitiated: null,
}

export const CARDINAL_CANCEL_REASONS = {
  clickCancelButton: '01',
}

export const CARDINAL_LIB_STATUSES = {
  pending: 'pending',
  ready: 'ready',
  failed: 'failed',
}

export const CARDINAL_CONNECTIVITY_ERRORS = {
  InitConnectionError: 10001,
  StartConnectionError: 10002,
  ValidateConnectionError: 10003,
  CentinelAPIConnectionErrorOnContinue: 10009,
  CentinelAPIConnectionErrorOnConfirm: 10007,
}

export const CARDINAL_GENERAL_ERRORS = {
  GeneralError: 10004,
}
